import classes from "app/css/widgets/FileInput.module.less";
import functions from "common/helper/functions";
import locale from "common/managers/locale";


function isDragEventForFiles(e) {
    const types = e.originalEvent?.dataTransfer?.types ?? [];
    return types.includes("Files");
}

export default class GlobalFileDragAndDrop {


    constructor() {
        this._registered = [];
        this._checkDrag = functions.debounce(this._checkDrag, 0, this);
        this._overCount = 0;
    }

    listen(element, multiple, drop) {
        const handler = {
            stop: () => {
                this._registered = this._registered.filter(r => r !== handler);
                this._stopGlobal();
                $(element).off(".GlobalFileDragAndDrop");
            },
            multiple,
            drop: drop
        }
        $(element)
            .on("drop.GlobalFileDragAndDrop", e => {
                if(isDragEventForFiles(e)) {
                    this._drop(e, handler);
                }
            });
        this._registered.push(handler);
        this._startGlobal();
        return handler;
    }

    _startGlobal() {
        if(this._registered.length === 1) {
            $(document.body)
                .on("dragover.GlobalFileDragAndDrop", e => {
                    if(isDragEventForFiles(e)) {
                        e.preventDefault();
                    }
                })
                .on("dragenter.GlobalFileDragAndDrop", e => {
                    if(isDragEventForFiles(e)) {
                        this._overCount++;
                        this._checkDrag();
                    }
                })
                .on("dragleave.GlobalFileDragAndDrop", e => {
                    if(isDragEventForFiles(e)) {
                        this._overCount--;
                        this._checkDrag();
                    }
                })
                .on("drop.GlobalFileDragAndDrop", e => {
                    if(isDragEventForFiles(e)) {
                        if(this._registered.length === 1) {
                            this._drop(e, this._registered[0]);
                        } else {
                            this._clearDrag(e);
                        }
                    }
                });
        }
    }

    _clearDrag(e) {
        e.preventDefault();
        e.stopPropagation();
        this._overCount = 0;
        this._checkDrag();
    }

    _drop(e, registered) {
        this._clearDrag(e);
        const items = [].slice.apply(e.originalEvent.dataTransfer.items)
        const files = items
            .filter(item => item.kind === "file")
            .map(item => {
                if(item.webkitGetAsEntry && item.webkitGetAsEntry()?.isDirectory) {
                    return {
                        size: 0,
                        name: item.getAsFile().name,
                    }
                } else {
                    return item.getAsFile();
                }
            });
        registered.drop(files);
    }

    _checkDrag() {
        $(document.body).toggleClass(classes.dragging, this._registered.length > 0 && this._overCount > 0);
        this._checkOverlay();
    }

    _checkOverlay() {
        if((this._overCount === 0 || this._registered.length === 0) && this._overlay) {
            this._overlay.remove();
            delete this._overlay;
        } else if(!this._overlay && this._registered.length === 1 && this._overCount > 0) {
            this._overlay = $("<div></div>", {
                "class": classes.fileInputOverlay
            });
            const div = $("<div></div>");
            div.append($("<div></div>", {
                "aria-hidden": "true",
                "class": classes.overlayIcon,
                text: "]"
            }));
            div.append($("<div></div>", {
                text: locale.get(this._registered[0].multiple ? "drop.files.upload" : "drop.file.upload")
            }));
            this._overlay.append(div);
            $(document.body).append(this._overlay);
        }
    }

    _stopGlobal() {
        if(this._registered.length === 0) {
            $(document.body).off(".GlobalFileDragAndDrop");
            this._checkDrag();
        }
    }
}
